import { TableContainer } from "@mui/material"
import styles from "../Utils/table.module.css"

const HTML_Form = (props) => {
    const { columns = [], config = {} } = props

    return (
        <TableContainer
            sx={{
                scrollbarWidth: "thin",
                scrollbarColor: "#0000FF #00000000",
                pb: 1,
            }}
        >
            <table className={styles['form-table']}>
                <thead className={styles['form-thead']}>
                    {columns?.map((column, colIndex) => {
                        if (!!column?.isHeading) {
                            return (
                                <tr key={colIndex} className={styles['form-trRow']}>
                                    <th
                                        colSpan={2}
                                        className={`${styles['form-thCell']}`}
                                        style={{ textAlign: "center" }}
                                    >
                                        {column?.name}
                                    </th>
                                </tr>
                            )
                        }
                        return (
                            <tr key={colIndex} className={styles['form-trRow']}>
                                <th className={styles['form-thCell']}>{column?.name}</th>
                                <td className={styles['form-tdCell']}></td>
                            </tr>
                        )
                    })}
                </thead>
            </table>
        </TableContainer>
    )
}

export default HTML_Form
